import { Controller } from "@hotwired/stimulus";

import { prefersReducedMotion } from "~/lib/viewport";

export default class WebRevealController extends Controller<HTMLElement> {
  static override targets = ["item"];
  declare readonly itemTargets: HTMLElement[];

  private observer: IntersectionObserver | null = null;

  override connect(): void {
    if (prefersReducedMotion()) return;
    // base.css scopes the hidden state to this class, so it is added here
    // rather than rendered in the markup: without it the copy stays visible.
    this.element.classList.add("is-revealing");
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" },
    );
    for (const item of this.itemTargets) observer.observe(item);
    this.observer = observer;
  }

  override disconnect(): void {
    this.observer?.disconnect();
    this.observer = null;
    this.element.classList.remove("is-revealing");
  }
}
